import(/* webpackMode: "eager" */ "/home/skillmate/public_html/meet/frontend/src/app/page.tsx");
